﻿(function (angular, document) {
  "use strict";

  var PERCENT_TO_FRACTION_MULTIPLIER = 0.01;
  var STAGE_PADDING_FALLBACK_WIDTH_PX = 14;

  angular.module("Toyota.Directives").directive("tyOwlCarousel", [
    "$rootScope",
    "GlobalBreakpoints",
    "CssMediaWatcher",
    "ScrollLock",
    "$analytics",
    "$window",
    function ($rootScope, GlobalBreakpoints, CssMediaWatcher, ScrollLock, $analytics, $window) {
      var link = function ($scope, $element) {
        var navPositioningRulesByBreakpoint;
        var cssMediaWatcher;
        var $owlCarousel;
        var $stageOuter;
        var $nav;
        var $navPrev;
        var $navNext;
        var $navStickyWrapper;
        var $navAnchorWrapper;
        var navState = {
          anchorWrapperPreStickyTop: null,
          stickyWrapperTop: null,
          anchorWrapperPostStickyTop: null,
          isPreSticky: true,
          isSticky: false,
          isPostSticky: false,
        };
        var moreItemsOffscreen;

        function updateAndRepaintWidthDependants(event) {
          var doTheRestOfTheUpdate = function () {
            updateNavAnchorWrapperTop();
            updateNavSticky();
            repaintNav();
            updateEnableDragging(event);
          };

          if ($element.find("[data-ty-maintain-height-group]").length) {
            var maintainHeightId = $element.closest("[data-ty-maintain-height-id]").attr("data-ty-maintain-height-id");
            if (maintainHeightId) {
              $rootScope.$broadcast("force-maintain-height", maintainHeightId, doTheRestOfTheUpdate);
            }
          } else {
            doTheRestOfTheUpdate();
          }
        }

        function updateEnableDragging(event) {
          moreItemsOffscreen = event.item.count > event.page.size;
        }

        function repaintNav() {
          $navAnchorWrapper.css({
            top: navState.anchorWrapperPreStickyTop,
          });

          $navStickyWrapper.css({
            position: navState.isSticky ? "fixed" : "",
            top: navState.isSticky ? navState.stickyWrapperTop : "",
          });

          $nav.css({
            top:
              getCurrentNavPositioningRule().sticky && navState.isPostSticky
                ? navState.anchorWrapperPostStickyTop - navState.anchorWrapperPreStickyTop
                : "",
          });
        }

        function getNavHeight() {
          var navPrevRect = $navPrev.get(0).getBoundingClientRect();
          var navNextRect = $navNext.get(0).getBoundingClientRect();
          return Math.max(navPrevRect.bottom, navNextRect.bottom) - Math.min(navPrevRect.top, navNextRect.top);
        }

        function updateNavSticky() {
          if (!$nav.length) {
            return;
          }

          var navHeight = getNavHeight();
          var navAnchorWrapperTop =
            $owlCarousel.get(0).getBoundingClientRect().top + navState.anchorWrapperPreStickyTop;
          var viewportHeight = document.documentElement.clientHeight;
          var preStickyPosInViewport = navAnchorWrapperTop;
          var stickyPos = viewportHeight / 2 - navHeight / 2;
          var postStickyPosInViewport =
            preStickyPosInViewport + (navState.anchorWrapperPostStickyTop - navState.anchorWrapperPreStickyTop);

          if (navState.stickyPosType === "fraction") {
            stickyPos = viewportHeight * navState.stickyPosFraction;
          }

          navState.isPostSticky = postStickyPosInViewport <= stickyPos;
          navState.isSticky = preStickyPosInViewport <= stickyPos && !navState.isPostSticky;
          navState.isPreSticky = !(navState.isPostSticky || navState.isSticky);

          navState.stickyWrapperTop = stickyPos;
          navState.isSticky = navState.isSticky && getCurrentNavPositioningRule().sticky;
        }

        function updateNavAnchorWrapperTop() {
          if (!$nav.length) {
            return;
          }

          var currentNavPositioningRule = getCurrentNavPositioningRule();
          var navInitialPositionSourceSelector;
          var navInitialPositionAlign;
          var navFinalPositionSourceSelector;
          var navFinalPositionAlign;
          var percentageRegex = /([0-9.]+)%$/;

          navState.stickyPosType = "fraction";
          navState.stickyPosFraction = 0.5;

          if (currentNavPositioningRule) {
            if (currentNavPositioningRule.preStickyPosition) {
              navInitialPositionSourceSelector = currentNavPositioningRule.preStickyPosition.sourceSelector;
              navInitialPositionAlign = currentNavPositioningRule.preStickyPosition.align;
            }

            if (currentNavPositioningRule.postStickyPosition) {
              navFinalPositionSourceSelector = currentNavPositioningRule.postStickyPosition.sourceSelector;
              navFinalPositionAlign = currentNavPositioningRule.postStickyPosition.align;
            }

            if (
              currentNavPositioningRule.stickyPosition &&
              currentNavPositioningRule.stickyPosition.match(percentageRegex)
            ) {
              navState.stickyPosType = "fraction";
              navState.stickyPosFraction =
                PERCENT_TO_FRACTION_MULTIPLIER *
                $window.parseFloat(currentNavPositioningRule.stickyPosition.match(percentageRegex)[0]);
            }
          }

          var $navInitialPosSource = navInitialPositionSourceSelector
            ? $element.find(navInitialPositionSourceSelector)
            : $stageOuter;
          var $navFinalPosSource = navFinalPositionSourceSelector
            ? $element.find(navFinalPositionSourceSelector)
            : $stageOuter;

          var alignmentMap = {
            top: 0,
            middle: 0.5,
            bottom: 1.0,
          };

          var $navPosContext = $element.find(".owl-carousel");

          var navHeight = getNavHeight();

          var navInitialPosSourceRect = $navInitialPosSource.get(0).getBoundingClientRect();
          var navInitialPosSourceHeight = navInitialPosSourceRect.bottom - navInitialPosSourceRect.top;
          var navInitialPosAlignFraction = navInitialPositionAlign ? alignmentMap[navInitialPositionAlign] : 0.5;
          var navInitialPosAlignOffset =
            navInitialPosAlignFraction * navInitialPosSourceHeight - navInitialPosAlignFraction * navHeight;

          var navFinalPosSourceRect = $navFinalPosSource.get(0).getBoundingClientRect();
          var navFinalPosSourceHeight = navFinalPosSourceRect.bottom - navFinalPosSourceRect.top;
          var navFinalPosAlignFraction = navFinalPositionAlign ? alignmentMap[navFinalPositionAlign] : 0.5;
          var navFinalPosAlignOffset =
            navFinalPosAlignFraction * navFinalPosSourceHeight - navFinalPosAlignFraction * navHeight;

          var navPosContextRect = $navPosContext.get(0).getBoundingClientRect();

          navState.anchorWrapperPreStickyTop =
            navInitialPosSourceRect.top + navInitialPosAlignOffset - navPosContextRect.top;
          navState.anchorWrapperPostStickyTop =
            navFinalPosSourceRect.top + navFinalPosAlignOffset - navPosContextRect.top;
        }

        function triggerCarouselItemChangeAnalyticsEvent(direction, itemEventAction) {
          $analytics.eventTrack("gaClick", {
            eventCategory: $scope.analyticsEventCategory || "carousel banner",
            eventAction: itemEventAction || $scope.analyticsEventAction || null,
            eventLabel: direction,
          });
        }

        function generateConfig(overrides) {
          var initialized = false;
          var lastIndex;
          var config = {
            items: 1,
            loop: false,
            nav: false,
            mouseDrag: false,
            touchDrag: function () {
              return false;
            },
            smartSpeed: 750,
            dragEndSpeed: 500,
            onInitialized: function (event) {
              initialized = true;
              findOwlCarouselElements();
              updateAndRepaintWidthDependants(event);
            },
            onRefreshed: function (event) {
              /*
               * suppress owlcarousel onRefreshed handler in between onInitialize and onInitialized --
               * we need access to additional elements which init creates
               */
              if (!initialized) {
                return;
              }

              updateAndRepaintWidthDependants(event);
            },
            onDrag: function () {
              angular.element($element).find(".owl-stage").addClass("owl-stage-drag-transition");
            },
            onTranslated: function () {
              angular.element($element).find(".owl-stage").removeClass("owl-stage-drag-transition");
              $rootScope.$broadcast("owl-carousel-slide-change-end");
            },
            navText:
              $scope.navTextPrevSrc || $scope.navTextNextSrc
                ? [angular.element($scope.navTextPrevSrc).html(), angular.element($scope.navTextNextSrc).html()]
                : undefined,
            onChanged: function (event) {
              if (lastIndex !== event.item.index) {
                $rootScope.$broadcast("owl-carousel-slide-change-begin");
              }

              if (initialized && lastIndex !== event.item.index) {
                var direction = event.item.index < lastIndex ? "left" : "right";
                lastIndex = event.item.index;
                var itemEventAction = $element
                  .find(".owl-item")
                  .eq(lastIndex)
                  .find("[data-ty-owl-carousel-analytics-item-event-action]")
                  .attr("data-ty-owl-carousel-analytics-item-event-action");
                triggerCarouselItemChangeAnalyticsEvent(direction, itemEventAction);
              }
            },
          };

          angular.extend(config, overrides);

          var $stagePaddingSource = angular.element($scope.stagePaddingSourceSelector);
          if ($stagePaddingSource.length) {
            config.stagePadding = function () {
              var paddingSourceRect = $stagePaddingSource.get(0).getBoundingClientRect();
              var paddingSourceWidth = paddingSourceRect.right - paddingSourceRect.left;
              if (paddingSourceWidth === 0) {
                return STAGE_PADDING_FALLBACK_WIDTH_PX;
              }

              return (document.body.clientWidth - paddingSourceWidth) / 2;
            };
          }

          return config;
        }

        function changeAppearanceIfFancyAccordionIsNext() {
          var $scOwlCarousel = $element.closest(".ty-sc-owl-carousel");
          if (
            $scOwlCarousel.hasClass("ty-sc-owl-carousel--vehicle-info") &&
            $scOwlCarousel.next().is("[data-ty-fancy-accordion]")
          ) {
            $scOwlCarousel.addClass("ty-sc-owl-carousel--fancy-accordion");
          }
        }

        function findOwlCarouselElements() {
          $stageOuter = $stageOuter && $stageOuter.length ? $stageOuter : $element.find(".owl-stage-outer");
          $nav = $nav && $nav.length ? $nav : $element.find(".owl-nav");
          $navPrev = $navPrev && $navPrev.length ? $navPrev : $element.find(".owl-prev");
          $navNext = $navNext && $navNext.length ? $navNext : $element.find(".owl-next");
          $navStickyWrapper =
            $navStickyWrapper && $navStickyWrapper.length
              ? $navStickyWrapper
              : $nav.wrap('<div class="ty-owl-carousel-nav-sticky-wrapper"></div>').parent();
          $navAnchorWrapper =
            $navAnchorWrapper && $navAnchorWrapper.length
              ? $navAnchorWrapper
              : $navStickyWrapper.wrap('<div class="ty-owl-carousel-nav-anchor-wrapper"></div>').parent();
        }

        function proxyDragHandlers() {
          var owlCarouselApi = $owlCarousel.data("owl.carousel");
          var oldDragStart = owlCarouselApi.onDragStart;
          var oldDragMove = owlCarouselApi.onDragMove;
          var oldDragEnd = owlCarouselApi.onDragEnd;

          var disableDraggingIfNoItemsOffscreen = $scope.disableElasticDraggingOnItemOverflow === "true";

          var isScrollingPage = false;
          var scrollTopStart = null;
          var scrollTopBuffer = [];

          function updateIsScrollingPage() {
            var scrollTop = document.documentElement.scrollTop;

            if (!scrollTopStart) {
              scrollTopStart = scrollTop;
            }

            scrollTopBuffer.unshift(scrollTop);
            if (scrollTopBuffer.length > 2) {
              scrollTopBuffer.pop();
            }

            isScrollingPage = isScrollingPage || (scrollTopStart !== scrollTop && !ScrollLock.isLocked);
          }

          owlCarouselApi.onDragStart = function () {
            if (!isScrollingPage && (disableDraggingIfNoItemsOffscreen ? moreItemsOffscreen : true)) {
              oldDragStart.apply(this, arguments);
            }
          };

          owlCarouselApi.onDragMove = function () {
            updateIsScrollingPage();

            if (!isScrollingPage && (disableDraggingIfNoItemsOffscreen ? moreItemsOffscreen : true)) {
              if (scrollTopBuffer.length > 1 && !ScrollLock.isLocked) {
                ScrollLock.lock();
              }

              oldDragMove.apply(this, arguments);
            }
          };

          owlCarouselApi.onDragEnd = function () {
            scrollTopStart = null;
            scrollTopBuffer = [];
            isScrollingPage = false;

            if (disableDraggingIfNoItemsOffscreen ? moreItemsOffscreen : true) {
              if (ScrollLock.isLocked) {
                ScrollLock.unlock();
              }

              oldDragEnd.apply(this, arguments);
            }
          };
        }

        function fillNavPositioningRulesByBreakpoint(navPositioningRules) {
          var rulesByBreakpoint = GlobalBreakpoints.all().reduce(function (acc, breakpoint) {
            acc[breakpoint] = {
              sticky: false,
              stickyPosition: "50%",
            };
            return acc;
          }, {});

          angular.forEach(navPositioningRules, function (rule) {
            var ruleBreakpoints = GlobalBreakpoints.parseCompoundExpression(rule.breakpoint);
            angular.forEach(ruleBreakpoints, function (ruleBreakpoint) {
              rulesByBreakpoint[ruleBreakpoint] = rule;
            });
          });
          return rulesByBreakpoint;
        }

        function getCurrentNavPositioningRule() {
          return navPositioningRulesByBreakpoint[cssMediaWatcher.getCurrentMedia().viewportWidth.breakpoint];
        }

        function init() {
          navPositioningRulesByBreakpoint = fillNavPositioningRulesByBreakpoint($scope.navPositioningRules || []);

          cssMediaWatcher = CssMediaWatcher({
            $el: angular.element(".ty-global-breakpoint-sensor"),
            pseudoEl: "before",
            mediaProperty: "viewportWidth",
            mediaRegexes: GlobalBreakpoints.all().reduce(function (mediaRegexes, breakpoint) {
              mediaRegexes[breakpoint] = "^" + breakpoint + "$";
              return mediaRegexes;
            }, {}),
          });

          $owlCarousel = angular.element($element).find(".js-owl-carousel");
          $owlCarousel.owlCarousel(generateConfig($scope.options));

          proxyDragHandlers();

          changeAppearanceIfFancyAccordionIsNext();

          function updateNavTopStickyAndRepaintNav() {
            updateNavSticky();
            repaintNav();
          }

          angular.element($window).on("scroll", updateNavTopStickyAndRepaintNav);
          angular.element($window).on("resize", updateNavTopStickyAndRepaintNav);
        }

        init();
      };

      return {
        scope: {
          navTextPrevSrc: "@?tyOwlCarouselNavPrevHtmlSrc",
          navTextNextSrc: "@?tyOwlCarouselNavNextHtmlSrc",
          options: "=?tyOwlCarouselConfig",
          stagePaddingSourceSelector: "@?tyOwlCarouselStagePaddingSourceSelector",
          navPositioningRules: "=?tyOwlCarouselNavPositioningRules",
          disableElasticDraggingOnItemOverflow: "@?tyOwlCarouselDisableElasticDraggingOnItemOverflow",
          analyticsEventCategory: "@?tyOwlCarouselAnalyticsEventCategory",
          analyticsEventAction: "@?tyOwlCarouselAnalyticsEventAction",
        },
        restrict: "A",
        // prettier-ignore
        template:
          '<div class="owl-carousel js-owl-carousel">' +
            "<div data-ng-transclude-replace></div>" +
          "</div>",
        transclude: true,
        link: link,
      };
    },
  ]);
})(window.angular, window.document);
